export enum FilialType {
  ГлавноеУправление = 1,
  МПП = 2,
  КПП = 3,
  ПБО = 4,
}
